import React from 'react';
import PageHero from './PageHero';
import { ArrowUpRight, Calendar, Clock, MapPin, Tag } from 'lucide-react';

export default function LatestNewsPage({ setPage }) {
  const newsItems = [
    {
      id: 1,
      title: "BSEISI Result",
      desc: "Great achievements await! The BSEISI Board results for the academic session are now published. Students and parents can access the official scorecards and performance analysis online. Congratulations to all high achievers!",
      linkText: "View Results",
      linkUrl: "https://onlineassesments.gmis.sch.id/certificate/index.php",
      image: "https://placehold.co/345x195",
      tag: "Academics",
      date: "Oct 2, 2026"
    },
    {
      id: 2,
      title: "Science Olympiad 2026",
      desc: "Inspire, Think, Solve. Join the GMISSO 2026 Science Olympiad designed for young learners (Grades 1–5). A platform to explore creativity, critical thinking, and scientific curiosity.",
      details: [
        { icon: <Calendar size={16} />, text: "Saturday, 16th May 2026" },
        { icon: <Clock size={16} />, text: "9:30 AM" },
        { icon: <MapPin size={16} />, text: "Registration Closes: 1st May" }
      ],
      linkText: "Register Now",
      linkUrl: "https://docs.google.com/forms/d/e/1FAIpQLSeIIroANRKm80NEGv5I8er1OnGaw53bV8y2Ql1qhuLyYsewjQ/viewform",
      image: "https://placehold.co/345x195",
      tag: "Event",
      date: "Sep 28, 2026"
    },
    {
      id: 3,
      title: "Mid Term Report 2025-2026",
      desc: "Access and download your child's Mid Term Report for the academic year 2025-2026. View detailed performance insights and academic progress online.",
      linkText: "View Results",
      linkUrl: "https://onlineassesments.gmis.sch.id/certificate/index.php",
      image: "https://placehold.co/350x490",
      tag: "Notice",
      date: "Sep 20, 2026"
    }
  ];

  return (
    <div className="w-full bg-[#f8f9fa] min-h-screen pb-32">
      {/* ── Hero ─────────────────────────────────────────────────────────────── */}
      <PageHero title={"News & Updates"} breadcrumbs={["Home", "News & Events", "Latest News"]} eyebrow={"Announcements"} subtitle={"Stay informed with the latest happenings, announcements, and achievements at GMIS Jakarta."} />


      {/* ── Main Content ── */}
      <div className="max-w-[1200px] mx-auto px-6 lg:px-12 pt-16 ">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {newsItems.map((item) => (
            <a
              key={item.id}
              href={item.linkUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-white rounded-[20px] overflow-hidden shadow-[0_8px_30px_rgba(14,36,62,0.04)] hover:shadow-[0_20px_50px_rgba(14,36,62,0.1)] transition-all duration-300 border border-line flex flex-col group block hover:-translate-y-1"
            >
              {/* Image Area */}
              <div className="relative h-48 bg-navy/5 overflow-hidden shrink-0">
                <div className="absolute inset-0 bg-navy/10 group-hover:bg-transparent transition-colors duration-500 z-10" />
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-700"
                />
                <div className="absolute top-5 left-5 z-20">
                  <span className="bg-white/95 backdrop-blur text-navy text-[10px] font-bold uppercase tracking-widest px-3 py-1.5 rounded-full shadow-sm">
                    {item.tag}
                  </span>
                </div>
              </div>

              {/* Content Area */}
              <div className="p-6 flex-1 flex flex-col">
                <div className="flex items-center gap-2 text-ink/50 font-medium text-xs mb-4">
                  <Calendar size={14} />
                  {item.date}
                </div>

                <h3 className="text-2xl font-heading font-semibold text-navy mb-4 leading-tight group-hover:text-gold transition-colors duration-300">
                  {item.title}
                </h3>

                <p className="text-ink/70 leading-[1.7] text-[15px] mb-8 flex-1 line-clamp-3">
                  {item.desc}
                </p>

                <div className="mt-auto border-t border-line/60 pt-5">
                  <span className="inline-flex items-center gap-2 text-gold font-bold text-[13px] tracking-wider uppercase group-hover:text-navy transition-colors duration-300">
                    {item.linkText}
                    <ArrowUpRight size={16} className="transition-transform group-hover:translate-x-1 group-hover:-translate-y-1" />
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}
